// Drawer container
export const drawerContentContainer = (mobileScreen: boolean) => ({
  borderRadius: 0,
  width: mobileScreen ? '100%' : '408px',
});

export const drawerBody = {
  padding: '0 24px 24px',
};

// Affiliation row wrapper
export const affiliationRowContainer = {
  gap: '16px',
  paddingLeft: '20px',
};

// Section heading rows (icon + label)
export const sectionHeadingRow = {
  gap: '6px',
};

// Section wrappers
export const sectionContainer = {
  gap: '4px',
};

export const sectionContainerLarge = {
  gap: '6px',
};

// Title
export const affiliationTitleText = {
  fontWeight: 700,
  fontSize: '18px',
  color: '#002877',
  overflow: 'hidden',
  whiteSpace: 'pre-wrap' as const,
  textOverflow: 'ellipsis',
};

// Popover
export const infoPopoverCss = {
  '.abyss-popover-close-button': { width: '24px', height: '24px' },
  '.abyss-popover-close-icon': {
    color: '#4B4D4F',
    width: '24px',
    height: '24px',
  },
};

export const infoPopoverContentText = {
  width: '276px',
  fontFamily: 'sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '140%',
  color: '#4B4D4F',
};

export const infoIconCss = {
  cursor: 'pointer',
  flexShrink: 0,
};

// Accepting patients
export const acceptingRow = {
  gap: '8px',
};

export const acceptingText = {
  fontSize: '$md',
  color: '#323333',
};

// Enrollment ID
export const enrollmentIdRow = {
  paddingLeft: '26px',
  gap: '4px',
};

export const enrollmentIdText = {
  fontSize: '$sm',
  color: '#196ECF',
  fontWeight: 600,
};

// Sub-attribute indent rows
export const subAttributeIndentRow = (gap = '4px') => ({
  paddingLeft: '26px',
  gap,
});

// Sub-attribute text — normal value
export const subAttributeText = {
  fontSize: '$sm',
  color: '#323333',
};

// Sub-attribute text — not available
export const subAttributeUnavailableText = {
  fontSize: '$sm',
  color: '#4B4D4F',
};

// Sub-attribute padding variants
export const subAttributeTextIndented = {
  paddingLeft: '26px',
  fontSize: '$sm',
  color: '#323333',
};

export const subAttributeUnavailableTextIndented = {
  paddingLeft: '26px',
  fontSize: '$sm',
  color: '#4B4D4F',
};

// See more / See less toggle link
export const seeMoreToggleLink = {
  fontSize: '$sm',
  color: '#196ECF',
  fontWeight: '$normal',
  textDecoration: 'none',
  marginTop: '2px',
  alignSelf: 'flex-start' as const,
};

// Search link wrapper
export const searchAllLinkCss = {
  fontSize: '$md',
  fontWeight: 500,
  textDecoration: 'none',
  alignSelf: 'flex-start' as const,
};

export const searchAllLabelSpan: React.CSSProperties = {
  color: '#4B4D4F',
  fontWeight: 500,
  marginRight: '4px',
  fontSize: '12px',
};

export const searchAllNameSpan: React.CSSProperties = {
  color: '#196ECF',
  fontWeight: 700,
  fontSize: '12px',
};

// Dividing line between affiliations
export const affiliationDivider: React.CSSProperties = {
  width: '100%',
  height: '1px',
  backgroundColor: '#CBCCCD',
  margin: '16px 0',
};
